export enum PlatformType{
    PotLine,
    CuttingLine,
    SortingLine,
    Irrigation
}